import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormArray, Validators } from '@angular/forms';
import { SnackbarService } from '../../../_service/message-service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { ChargingSchedulePeriod } from '../../../modules/ocpp/models/ChargingSchedulePeriod';
import { ChargingProfilePurposeType } from '../../../modules/ocpp/enums/charging.profile.purpose.enum';
import { CreateChargingProfileRequest } from '../../../modules/ocpp/models/CreateChargingProfileRequest';
import { RecurrencyKindType } from '../../../modules/ocpp/enums/recurrency.kind.enum';
import { ChargingProfileKindType } from '../../../modules/ocpp/enums/charging.profile.kind.enum';
import { ChargingRateUnitType } from '../../../modules/ocpp/enums/charging.rate.unit.type.enum';
import { ChargingProfileService } from './charging-profile.service';
import { LoaderService } from '../../../loader.service';
import { AuthenticationService } from 'src/app/_services';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { UserInfoService } from 'src/app/_services/userInfo.service';
const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
    parse: {
        dateInput: 'l, LTS'
      },
      display: {
        dateInput: 'YYYY-MM-DD HH:mm:ss',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
      }
};



@Component({
    selector: 'telio-create-charging-profile',
    templateUrl: './create-charging-profile.component.html',
    styleUrls: ['./create-charging-profile.component.scss'],
    providers: [

        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },

        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
})
export class CreateChargingProfileComponent implements OnInit {
    schedulePeriodForm: UntypedFormGroup;
    public disabled = false;
    public showSpinners = true;
    public showSeconds = false;
    public touchUi = false;
    public enableMeridian = false;
    public stepMinutes = [0o0, 15, 30, 45];
    public stepHour = 1;
    public stepMinute = 15;
    public stepSecond = 1;
    public defaultTime = [new Date().getHours(), 0, 0]
    isLoaded = false;
    minDate: Date;
    constructor(
        private loaderService: LoaderService,
        private toasterService: SnackbarService,
        private formBuilder: UntypedFormBuilder,
        readonly translate: TranslateService,
        private router: Router,
        readonly routed: ActivatedRoute,
        private chargingProfileService: ChargingProfileService,
        readonly authenService: AuthenticationService,
        private userInfoService: UserInfoService,
    ) {
        // smart-charging
        this.chargingProfilePurposeTypeKeys = Object.keys(this.chargingProfilePurposeType);
        this.recurrencyKindTypeKeys = Object.keys(this.recurrencyKindType);
        this.chargingProfileKindTypeKeys = Object.keys(this.chargingProfileKindType);
        this.chargingRateUnitTypeKeys = Object.keys(this.chargingRateUnitType);

        this.chargingProfile = new CreateChargingProfileRequest();
    }

    get schedulePeriods() {
        return this.chargingProfileForm.controls["schedulePeriods"] as UntypedFormArray;
    }

    chargingSchedulePeriodList: ChargingSchedulePeriod[] = [];
    chargingProfile: CreateChargingProfileRequest;

    chargingProfilePurposeTypeKeys = [];
    recurrencyKindTypeKeys = [];
    chargingProfileKindTypeKeys = [];
    chargingRateUnitTypeKeys = [];
    recurrencyKindType = RecurrencyKindType;
    chargingProfileKindType = ChargingProfileKindType;
    chargingRateUnitType = ChargingRateUnitType;
    chargingProfilePurposeType = ChargingProfilePurposeType;

    chargingProfileForm = this.formBuilder.group({
        description: ['', [Validators.required]],
        minChargingRate: [],
        chargingRateUnit: [],
        startSchedule: [],
        durationInSeconds: [],
        validFrom: [''],
        validTo: [''],
        recurrencyKind: [],
        chargingProfileKind: ['', [Validators.required]],
        chargingProfilePurpose: ['', [Validators.required]],
        stackLevel: ['', [Validators.required]],
        schedulePeriods: this.formBuilder.array([])
    });

    count = 1;
    buttonDisable = false;
    // allow only numbers
    testdata = '';

    ngOnInit() {
        this.minDate = new Date();
        const nextyearDate = new Date();
        nextyearDate.setDate(nextyearDate.getDate() + 364);
        this.addChargingSchedulePeriod();
    }

    submitChargingProfileRequest(chargingProfile: CreateChargingProfileRequest) {
        if (!this.chargingProfileForm.valid) {
            this.chargingProfileForm.markAllAsTouched();
            return;
        }
        this.isLoaded = true;
        const chargingProfileReq = this.chargingProfileForm.getRawValue() as CreateChargingProfileRequest;
        // chargingProfileReq['validFrom']= this.authenService.convertToLocalTimeForPayload(this.chargingProfileForm.controls['validFrom'].value,this.userInfoService.userDetails.prefCountry);
        // chargingProfileReq['validTo']= this.authenService.convertToLocalTimeForPayload(this.chargingProfileForm.controls['validTo'].value, this.userInfoService.userDetails.prefCountry);
        chargingProfileReq['validFrom']=this.chargingProfileForm.controls['validFrom'].value ?this.authenService.convertToLocalTimeForPayload(this.chargingProfileForm.controls['validFrom'].value,this.userInfoService.userDetails.prefCountry):''
        chargingProfileReq['validTo']=this.chargingProfileForm.controls['validTo'].value ?this.authenService.convertToLocalTimeForPayload(this.chargingProfileForm.controls['validTo'].value, this.userInfoService.userDetails.prefCountry):''
        this.chargingProfileService.createChargingProfile(chargingProfileReq, this.userInfoService.userDetails.email).subscribe(response => {
            this.isLoaded = false;
            this.toasterService.success(this.translate.instant('ocpp.chargingProfile.createChargingProfileSuccess'));
            this.routeBack();
        }, error => {
            this.isLoaded = false;
            this.toasterService.error(this.translate.instant('ocpp.chargingProfile.createChargingProfileError'));
        });
    }

    addChargingSchedulePeriod() {
        const schedulePeriod = this.formBuilder.group({
            startPeriod: ['', [Validators.required]],
            powerLimit: ['', [Validators.required]],
            numberPhases: ['']
        });
        this.schedulePeriods.push(schedulePeriod);
    }

    deleteChargingSchedulePeriod(index: number) {
        this.chargingProfile._schedulePeriods.splice(index, 1);
        this.schedulePeriods.removeAt(index);
    }
    onSelected() {
        if (this.chargingProfile._validFrom > this.chargingProfile._validTo) {
            this.chargingProfile._validTo = null;
        }
    }
    resetmethod(createRfid, formDirective) {
        this.schedulePeriods.reset();
        this.chargingProfileForm.reset();
        this.chargingProfileForm.controls["schedulePeriods"].reset();
    }

    routeBack() {
        this.router.navigate(["/dashboard/charging-profiles", { routeID: this.routed.snapshot.paramMap.get('routeID') }]);
    }

    change(event) {
        if (!!event.startDate && !!event.endDate) {
            this.chargingProfile._validFrom = event.startDate.$d;
            this.chargingProfile._validTo = event.endDate.$d;
            this.chargingProfileForm.controls["validFrom"].setValue(event.startDate.$d);
            this.chargingProfileForm.controls["validTo"].setValue(event.endDate.$d);
        }
    }
}
